import { useRef, useEffect } from 'react';

const useCarouselImpressions = ({
  items,
  rows,
  logImpression,
  carouselInView,
  loading
}) => {
  const slidesReportedAsVisible = useRef([]);
  const impressionsLogged = useRef([]);

  useEffect(() => {
    slidesReportedAsVisible.current = new Array(
      Math.ceil(items.length / rows)
    ).fill(false);
    impressionsLogged.current = new Array(items.length).fill(false);
  }, [items, rows]);

  const logReported = () => {
    impressionsLogged.current.forEach((logged, index) => {
      if (logged) return;

      const slideIndex = Math.floor(index / rows);

      if (slidesReportedAsVisible.current[slideIndex]) {
        logImpression(items[index], index);
        impressionsLogged.current[index] = true;
      }
    });
  };

  useEffect(() => {
    if (carouselInView) logReported();
  }, [carouselInView]);

  const handleCarouselReport = report => {
    report.forEach((visible, index) => {
      if (visible) {
        slidesReportedAsVisible.current[index] = true;
      }
    });

    if (carouselInView) logReported();
  };

  if (loading) return () => {};

  return handleCarouselReport;
};

export default useCarouselImpressions;
